export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_07.1e51a666.gif";